import { render } from "./listComponent.vue?vue&type=template&id=a3639244"
import script from "./listComponent.vue?vue&type=script&lang=js"
export * from "./listComponent.vue?vue&type=script&lang=js"

import "./listComponent.vue?vue&type=style&index=0&id=a3639244&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__